<ng-container>
  <div class="modal-body text-center">
    <form class="form-signin" (ngSubmit)="validaForm()" #formulario="ngForm">
      <div class="row mt-4 mb-1">
        <div class="col-10 offset-1">
          <h5 class="text-blue text-uppercase">{{ label }}</h5>
          <input type="text" [(ngModel)]="claveForm" name="claveForm" [ngClass]="{ 'is-invalid': mostrarError && claveForm.length === 3 }" required />
          <div *ngIf="formulario.touched || mostrarError && claveForm.length === 3" class="invalid-feedback d-block">Por favor ingrese una clave válida.</div>
        </div>
      </div>

      <div class="row mt-4 mb-1">
        <div class="col-10 offset-1">
          <div class="row">
            <button class="btn-keyboard col" (click)="addNumber('1')" [ngClass]="{'no-click': disabledBtn}">1</button>
            <button class="btn-keyboard col" (click)="addNumber('2')" [ngClass]="{'no-click': disabledBtn}">2</button>
            <button class="btn-keyboard col" (click)="addNumber('3')" [ngClass]="{'no-click': disabledBtn}">3</button>
          </div>

          <div class="row">
            <button class="btn-keyboard col" (click)="addNumber('4')" [ngClass]="{'no-click': disabledBtn}">4</button>
            <button class="btn-keyboard col" (click)="addNumber('5')" [ngClass]="{'no-click': disabledBtn}">5</button>
            <button class="btn-keyboard col" (click)="addNumber('6')" [ngClass]="{'no-click': disabledBtn}">6</button>
          </div>

          <div class="row">
            <button class="btn-keyboard col" (click)="addNumber('7')" [ngClass]="{'no-click': disabledBtn}">7</button>
            <button class="btn-keyboard col" (click)="addNumber('8')" [ngClass]="{'no-click': disabledBtn}">8</button>
            <button class="btn-keyboard col" (click)="addNumber('9')" [ngClass]="{'no-click': disabledBtn}">9</button>
          </div>

          <div class="row">
            <button class="btn-keyboard col" [ngClass]="{'no-click': disabledBtn}"></button>
            <button class="btn-keyboard col" (click)="addNumber('0')" [ngClass]="{'no-click': disabledBtn}">0</button>
            <button class="btn-keyboard col" (click)="deleteNumber()" [ngClass]="{'no-click': isDisabled}">
              <i class="fas fa-backspace"></i>
            </button>
          </div>
        </div>
      </div>

      <button class="btn-gral next animated bounceIn slow" type="submit" (click)="changeForm($event, formulario)" [disabled]="disabled">Ingresar</button>
    </form>

    <div class="row mt-4" *ngIf="mostrarOpciones">
      <div class="col-4">
        <button type="button" class="btn-gral w-100 next animated bounceIn slow" (click)="apagar()">
          Apagar
        </button>
      </div>
      <div class="col-4">
        <button type="button" class="btn-gral w-100 next animated bounceIn slow" (click)="reiniciar()">
          Reiniciar
        </button>
      </div>
      <div class="col-4">
        <button type="button" class="btn-gral w-100 next animated bounceIn slow" (click)="cierreTBK()">
          Cierre Transbank
        </button>
      </div>
    </div>
  </div>

  <div class="row mb-4 text-center">
    <div class="col-12">
      <button type="button" class="btn-gral next animated bounceIn slow" (click)="closeModal()">
        Salir
      </button>
    </div>
  </div>
</ng-container>
